import BaseClient from './BaseClient';

class ImportsClient extends BaseClient {
    list(teamId, importType, params) {
        return this.makeCoreApiRequest(`${this.apiBase}/teams/${teamId}/imports/${importType}`, 'GET', null, params);
    }
    listErrors(teamId, importType, importId, params) {
        return this.makeCoreApiRequest(
            `${this.apiBase}/teams/${teamId}/imports/${importType}/${importId}/errors`,
            'GET',
            null,
            params
        );
    }

    getPromotionImports(teamId, promotionId, importType, params) {
        return this.makeCoreApiRequest(
            `${this.apiBase}/teams/${teamId}/promotions/${promotionId}/imports/${importType}`,
            'get',
            null,
            params
        );
    }

    getPromotionImportErrors(teamId, promotionId, importType, importId, params) {
        return this.makeCoreApiRequest(
            `${this.apiBase}/teams/${teamId}/promotions/${promotionId}/imports/${importType}/${importId}/errors`,
            'get',
            null,
            params
        );
    }
}

export default new ImportsClient({
    apiBase: window.Spark.apiBase,
});
